import {
  TOGGLE_LOADING_OVERLAY,
  TOGGLE_MOBILE_FILTERS_OVERLAY
} from '../../actions/actionTypes'

const uiToggles = (state = {}, action) => {
  switch (action.type) {
    case TOGGLE_LOADING_OVERLAY:
      return Object.assign({}, state, {
        loadingOverlay: action.doDisplay
      })
    case TOGGLE_MOBILE_FILTERS_OVERLAY:
      return Object.assign({}, state, {
        currentMobileFilter: action.filterName
      })
    default:
      return state
  }
}

export { uiToggles }
